<bn-loading-overlay></bn-loading-overlay>

<h5>Tarefas para honra</h5>

<div class="container">
  <div ngbAccordion>

  <div ngbAccordionItem>
    <h2 ngbAccordionHeader>
      <button ngbAccordionButton class="title11">Criar Janela Solicitação de Honra</button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <div class="row">
            <div class="col-md-3">
              <label for="anoMesSolicitacaoDeHonra">Data:</label>
              <input type="text" id="anoMesSolicitacaoDeHonra" class="form-control" bnMask="MESANO"
                [(ngModel)]="anoMesSolicitacaoDeHonra">
            </div>
          </div>
          <div class="row">
            <div class="submit col-auto">
              <button type="button" class="btn btn-success no-margin"
                (click)="consultaJanelaSolicitacaoHonra()">Consultar</button>
            </div>
            <div class="submit col-auto">
              <button type="button" class="btn btn-success no-margin"
                (click)="criaJanelaSolicitacaoHonra()">Criar</button>
            </div>
            <div class="submit col-auto">
              <button type="button" class="btn btn-light" (click)="limparSolicitacaoHonra()">Limpar</button>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <div ngbAccordionItem>
    <h2 ngbAccordionHeader>
      <button ngbAccordionButton class="title">Alterar Limite Disponível de Stop Loss de Agente em Cesta</button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <div class="row">

            <div class="col-md-3">
              <label for="cnpj">CNPJ: </label>
              <input type="text" id="cnpj" class="form-control" bnMask="CNPJ" [(ngModel)]="cnpjAgenteFinanceiro">
            </div>

            <div class="col-md-3">
              <label for="tranche">Cesta: </label>
              <select id="tranche" class="form-select" [(ngModel)]="ideTranche">
                <option [ngValue]=null></option>
                <option [ngValue]="tranche.id" *ngFor="let tranche of tranches">
                  {{tranche.numeroTranche}} ({{tranche.dataInicioContratacao | date: 'dd/MM/yyyy'}})</option>
              </select>
            </div>

            <div class="col-md-3">
              <label for="anoMesLimiteDisponivel">Data de referência<i class="fa fa-question-circle help-subtitulo"
                  placement="top-right" ngbTooltip="
                  O mês de referência de simulação do Stop Loss. Deve ser o mês anterior ao da janela de envio de solicitações de honra."></i>:</label>
              <input type="text" id="anoMesLimiteDisponivel" class="form-control" bnMask="MESANO"
                [(ngModel)]="anoMesLimiteDisponivel">
            </div>

            <div class="col-md-3">
              <label for="valor">Valor Disponível: </label>
              <input type="text" id="valor" class="form-control" bnMask="DECIMAL" casasDecimais="2"
                [(ngModel)]="valorDisponivel">
            </div>

          </div>

          <div class="row">

            <div class="submit col-auto">
              <button type="button" class="btn btn-success no-margin" (click)="alterarLimiteStopLoss()">Alterar</button>
            </div>
            <div class="submit col-auto">
              <button type="button" class="btn btn-light" (click)="limparLimiteDisponivel()">Limpar</button>
            </div>

          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <div ngbAccordionItem>
    <h2 ngbAccordionHeader>
      <button ngbAccordionButton class="title12">Criar Solicitação de Honra</button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>

          <div class="row">
            <div class="col-md-3">
              <label for="idOperacao">Id Operação:</label>
              <input type="text" id="idOperacao" class="form-control" bnMask="INTEIRO" [(ngModel)]="idOperacao">
            </div>
          </div>

          <div class="row">
            <div class="submit col-auto">
              <button type="button" class="btn btn-success no-margin" (click)="criaSolicitacaoHonra()">Criar</button>
            </div>
            <div class="submit col-auto">
              <button type="button" class="btn btn-light" (click)="limparCriarSolicitacaoHonra()">Limpar</button>
            </div>
          </div>

        </ng-template>
      </div>
    </div>
  </div>

  <div ngbAccordionItem>
    <h2 ngbAccordionHeader>
      <button ngbAccordionButton class="title2">Alterar Estado de Solicitação de Honra</button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <div class="row">


              <div class="col-md-3">
            <label for="alterarIdSh">Id Solicitação Honra:</label>
            <input type="text" id="alterarIdSh" class="form-control"
            bnMask="INTEIRO" [(ngModel)]="alterarIdSh">
          </div>

          <div class="col-md-3">
            <label for="idEstado">Estado:</label>
            <select id="idEstado" class="form-select" [(ngModel)]="idEstado">
              <option [ngValue]=null>Todos</option>
              <option [ngValue]="estado.id" *ngFor="let estado of estados">
                {{estado.nome}}
              </option>
            </select>
          </div>
        </div>

          <div class="row">

            <div class="submit col-auto">
              <button type="button" class="btn btn-success no-margin"
                (click)="alterarEstadoSolicitacaoHonra()">Alterar</button>
            </div>
            <div class="submit col-auto">
              <button type="button" class="btn btn-light" (click)="limparEstadoSolicitacaoHonra()">Limpar</button>
            </div>

          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <div ngbAccordionItem>
    <h2 ngbAccordionHeader>
      <button ngbAccordionButton class="title8">Remover Solicitação de Honra</button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <div class="row">

            <div class="col-md-3">
              <label for="removerIdSh">Id Solicitação Honra:</label>
              <input type="text" id="removerIdSh" class="form-control" bnMask="INTEIRO" [(ngModel)]="removerIdSh">
            </div>

          </div>

          <div class="row">

            <div class="submit col-auto">
              <button type="button" class="btn btn-success no-margin"
                (click)="removerSolicitacaoHonra()">Remover</button>
            </div>
            <div class="submit col-auto">
              <button type="button" class="btn btn-light" (click)="limparRemoverSolicitacaoHonra()">Limpar</button>
            </div>

          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <div ngbAccordionItem>
    <h2 ngbAccordionHeader>
      <button ngbAccordionButton class="title3">Rodar Stop Loss</button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <div class="row">
            <div class="submit col-6">
              <button type="button" class="btn btn-success no-margin" (click)="rodarStopLoss()">Rodar</button>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <div ngbAccordionItem>
    <h2 ngbAccordionHeader>
      <button ngbAccordionButton class="title4">Rodar Fechamento da Janela</button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <div class="row">
            <div class="submit col-6">
              <button type="button" class="btn btn-success no-margin"
                (click)="fecharJanelaSolicitacaoHonra()">Rodar</button>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <div ngbAccordionItem>
    <h2 ngbAccordionHeader>
      <button ngbAccordionButton class="title5">Processar Solicitações de Honra de Crédito Livre</button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <div class="row">
            <div class="submit col-6">
              <button type="button" class="btn btn-success no-margin"
                (click)="processarSolicitacoesHonraCreditoLivre()">Processar Todas (com críticas)</button>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-md-3">
              <label for="processarSHCreditoLivreIdSh">Id Solicitação Honra:</label>
              <input type="text" id="processarSHCreditoLivreIdSh" class="form-control" bnMask="INTEIRO"
                [(ngModel)]="processarSHCreditoLivreIdSh">
            </div>
            <div class="submit col-auto">
              <button type="button" class="btn btn-success no-margin"
                (click)="processarSolicitacaoHonraCreditoLivre()">Processar SH específica (sem críticas)</button>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <div ngbAccordionItem>
    <h2 ngbAccordionHeader>
      <button ngbAccordionButton class="title6">Processar Solicitações de Honra de Repasse</button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <div class="row">
            <div class="submit col-6">
              <button type="button" class="btn btn-success no-margin"
                (click)="processarSolicitacoesHonraRepasse()">Processar Todas (com críticas)</button>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-md-3">
              <label for="processarSHRepasseIdSh">Id Solicitação Honra:</label>
              <input type="text" id="processarSHRepasseIdSh" class="form-control" bnMask="INTEIRO"
                [(ngModel)]="processarSHRepasseIdSh">
            </div>
          </div>
          <div class="row">
            <div class="submit col-auto">
              <button type="button" class="btn btn-success no-margin"
                (click)="processarSolicitacaoHonraRepasse()">Processar SH específica (sem críticas)</button>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <div ngbAccordionItem>
    <h2 ngbAccordionHeader>
      <button ngbAccordionButton class="title13">Desfazer Processamento de Honra</button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <div class="row">

            <div class="col-md-3">
              <label for="desfazerIdSh">Id Solicitação Honra:</label>
              <input type="text" id="desfazerIdSh" class="form-control" bnMask="INTEIRO" [(ngModel)]="desfazerIdSh">
            </div>

          </div>

          <div class="row">

            <div class="submit col-auto">
              <button type="button" class="btn btn-success no-margin"
                (click)="desfazerProcessamentoDeHonra()">Desfazer</button>
            </div>
            <div class="submit col-auto">
              <button type="button" class="btn btn-light"
                (click)="limparDesfazerProcessamentoDeHonra()">Limpar</button>
            </div>

          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <div ngbAccordionItem>
    <h2 ngbAccordionHeader>
      <button ngbAccordionButton class="emitirFaturas">Emitir faturas</button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <div class="row">
          </div>
          <div class="row">
            <div class="submit col-6">
              <button type="button" class="btn btn-success no-margin" (click)="emitirFaturas()">Emitir</button>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>


  <div ngbAccordionItem>
    <h2 ngbAccordionHeader>
      <button ngbAccordionButton class="emitirRelarioProvPag">Emitir relatório - Provisão pagamentos</button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <div class="row">
          </div>
          <div class="row">
            <div class="submit col-6">
              <button type="button" class="btn btn-success no-margin"
                (click)="emitirRelatoriosProvisaoPagamentos()">Emitir</button>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>


  <div ngbAccordionItem>
    <h2 ngbAccordionHeader>
      <button ngbAccordionButton class="emitirRelatorioDefin">Emitir relatório - DEFIN</button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <div class="row">
          </div>
          <div class="row">
            <div class="submit col-6">
              <button type="button" class="btn btn-success no-margin" (click)="emitirRelatorioDefin()">Emitir</button>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <div ngbAccordionItem>
    <h2 ngbAccordionHeader>
      <button ngbAccordionButton class="title7">Simular Pagamento</button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <div class="row">

            <div class="col-md-3">
              <label for="simularPagamentoIdSh">Id Solicitação Honra:</label>
              <input type="text" id="simularPagamentoIdSh" class="form-control" bnMask="INTEIRO"
                [(ngModel)]="simularPagamentoIdSh">
            </div>

          </div>

          <div class="row">

            <div class="submit col-auto">
              <button type="button" class="btn btn-success no-margin" (click)="simularPagamento()">Simular</button>
            </div>
            <div class="submit col-auto">
              <button type="button" class="btn btn-light" (click)="limparSimularPagamento()">Limpar</button>
            </div>

          </div>

        </ng-template>
      </div>
    </div>
  </div>


  <div ngbAccordionItem>
    <h2 ngbAccordionHeader>
      <button ngbAccordionButton class="title9">Monitorar pagamento de faturas</button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <div class="row">
            <div class="submit col-6">
              <button type="button" class="btn btn-success no-margin"
                (click)="monitorarPagamentoFaturas()">Monitorar</button>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>


  <div ngbAccordionItem>
    <h2 ngbAccordionHeader>
      <button ngbAccordionButton class="title9">Emitir Extratos de Pagamento</button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <div class="row">

          </div>

          <div class="row">

            <div class="submit col-6">
              <button type="button" class="btn btn-success no-margin" (click)="emitirExtratosPagamento()">Emitir</button>
            </div>

          </div>

        </ng-template>
      </div>
    </div>
  </div>

  <div ngbAccordionItem>
    <h2 ngbAccordionHeader>
      <button ngbAccordionButton class="title10">Emitir Relatórios de Valores Honrados a Recuperar</button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <div class="row">

          </div>

          <div class="row">

            <div class="submit col-6">
              <button type="button" class="btn btn-success no-margin"
                (click)="emitirRelatoriosValoresHonradosRecuperar()">Emitir</button>
            </div>


          </div>

        </ng-template>
      </div>
    </div>
  </div>

  </div>
</div>


